import { api, getAuthorizationToken } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';

export default class FormBuilderApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async loadDocumentDefaultFields(doc_type: string): Promise<any> {
    const data = {
      params: {
        doc_type: doc_type,
        profile: 'DEFAULT',
      },
    };
    return super.get(api.get_field_settings_by_type, data);
  }

  public async getLayoutTemplates(queries: dynamicObj): Promise<any> {
    let querystring = '';
    if (Object.keys(queries).length !== 0) {
      querystring += '?';
      querystring += this.encodeQueryData(queries);
    }

    return super.get(api.get_layout_templates + querystring, {});
  }

  public async getAllLayoutTemplates(queries: dynamicObj): Promise<any> {
    let querystring = '';
    if (Object.keys(queries).length !== 0) {
      querystring += '?';
      querystring += this.encodeQueryData(queries);
    }

    return super.get(api.get_all_layout_templates + querystring, {});
  }

  public async getLayoutTemplateId(layoutId: string): Promise<any> {
    return super.get(api.document_layout_template_by_id + layoutId, {});
  }

  public async getDocumentLayoutTemplateById(layoutId: string): Promise<any> {
    return super.get(api.document_layout_template_by_id + layoutId, {});
  }

  public async createDocumentLayoutTemplate(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.post(api.create_layout_templates, formData);
  }

  public async updateDocumentLayoutTemplateById(
    data: any,
    layoutId: string,
  ): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.put(api.document_layout_template_by_id + layoutId, formData);
  }

  public async deleteDocumentLayoutTemplate(templateId: any): Promise<any> {
    return super.delete(api.document_layout_template_by_id + templateId, {});
  }

  public async applyDefaultLayoutToOrigins(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.post(api.apply_default_to_origins, formData);
  }
}
